// Schema.org structured data for SEO

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "BeautySalon",
  "name": "Let's Face It Studio",
  "description": "Luxury on-location makeup artistry for weddings, editorials, and private events. Mobile makeup services serving Atlanta and surrounding areas.",
  "url": "https://letsfaceitcosmetics.com",
  "logo": "https://letsfaceitcosmetics.com/images/LFI_Light.png",
  "image": "https://letsfaceitcosmetics.com/images/og-image.jpg",
  "telephone": "+1-678-313-9600",
  "email": "hello@letsfaceitcosmetics.com",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Atlanta",
    "addressRegion": "GA",
    "addressCountry": "US"
  },
  "areaServed": {
    "@type": "City",
    "name": "Atlanta"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Makeup Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Bridal Makeup",
          "description": "On-location bridal makeup for weddings"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Event Makeup",
          "description": "Professional makeup for special events"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Editorial Makeup",
          "description": "High-fashion makeup for photoshoots and runway"
        }
      }
    ]
  },
  "sameAs": [
    "https://www.instagram.com/lets.face.it.makeup/"
  ]
};

export const serviceSchema = (serviceName: string, description: string) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "provider": {
    "@type": "BeautySalon",
    "name": "Let's Face It Studio",
    "url": "https://letsfaceitcosmetics.com"
  },
  "description": description,
  "areaServed": {
    "@type": "City",
    "name": "Atlanta"
  }
});

export const bridalMakeupSchema = serviceSchema(
  "Bridal Makeup",
  "Professional bridal makeup services for weddings, including trials and day-of application"
);

export const editorialMakeupSchema = serviceSchema(
  "Editorial Makeup",
  "High-fashion editorial makeup for photoshoots, runway, and fashion events"
);

export const eventMakeupSchema = serviceSchema(
  "Event Makeup",
  "Luxury makeup services for special events, galas, and red carpet occasions"
);

export const createReviewSchema = (reviews: Array<{
  author: string;
  rating: number;
  date: string;
  text: string;
}>) => ({
  "@context": "https://schema.org",
  "@type": "BeautySalon",
  "name": "Let's Face It Studio",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length,
    "reviewCount": reviews.length,
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": reviews.map(review => ({
    "@type": "Review",
    "author": {
      "@type": "Person",
      "name": review.author
    },
    "datePublished": review.date,
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.rating,
      "bestRating": "5",
      "worstRating": "1"
    },
    "reviewBody": review.text
  }))
});

export const createFAQSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const breadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});
